module.exports = __webpack_public_path__ + "img/toutiao.9f22fa5a.png";